/* Product page behaviour (sections: main-product, product-faq, product-bundle, product-recommendations,
   product-recently-viewed). Plain ES5, event delegated, re-initialised on shopify:section:load.
   Add to cart (AJAX + toast) and the wishlist heart are handled globally by theme.js. */
(function () {
  'use strict';
  if (window.__productPage) return;
  window.__productPage = true;

  var Theme = window.Theme || {};
  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) { return Theme.money ? Theme.money(cents) : (cents / 100).toFixed(2); };
  var esc = function (s) { return Theme.escape ? Theme.escape(s) : String(s); };
  var RECENT_KEY = 'theme.recently_viewed';

  function storageGet(key) { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; } }
  function storageSet(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ } }

  /* ---------- mobile Owl carousels (thumbnails, highlights, bundle) ---------- */
  var OWL = {
    thumbs: { autoWidth: true, items: 1, margin: 10, nav: false, dots: false, loop: false, mouseDrag: true, touchDrag: true, smartSpeed: 350 },
    highlights: { autoWidth: true, items: 1, margin: 12, nav: false, dots: true, loop: false, mouseDrag: true, touchDrag: true, smartSpeed: 350 },
    fbt: { items: 2, margin: 12, nav: false, dots: true, loop: false, mouseDrag: true, touchDrag: true, smartSpeed: 350, stagePadding: 0 }
  };
  function syncOwl() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.owlCarousel) return;
    var mobile = window.matchMedia('(max-width: 991.98px)').matches;
    qsa('[data-owl-mobile]').forEach(function (node) {
      var cfg = OWL[node.getAttribute('data-owl-mobile')];
      if (!cfg) return;
      var el = $(node);
      var loaded = el.hasClass('owl-loaded');
      if (mobile && !loaded) { el.addClass('owl-carousel'); el.owlCarousel(cfg); }
      else if (!mobile && loaded) { el.trigger('destroy.owl.carousel'); el.removeClass('owl-carousel owl-loaded'); }
    });
  }
  function owlGoTo(node, index) {
    var $ = window.jQuery;
    if ($ && node && $(node).hasClass('owl-loaded')) $(node).trigger('to.owl.carousel', [index, 350, true]);
  }

  /* ---------- desktop thumbnail strip: arrows, mouse drag, scroll state (touch uses native scrolling) ---------- */
  function initThumbScroller(root) {
    var strip = qs('[data-owl-mobile="thumbs"]', root);
    var up = qs('[data-thumbs-up]', root);
    var down = qs('[data-thumbs-down]', root);
    if (!strip || !up || !down) return;
    var desktop = window.matchMedia('(min-width: 992px)');

    function update() {
      var scrollable = desktop.matches && strip.scrollHeight > strip.clientHeight + 1;
      up.hidden = !scrollable;
      down.hidden = !scrollable;
      if (!scrollable) return;
      up.disabled = strip.scrollTop <= 1;
      down.disabled = strip.scrollTop + strip.clientHeight >= strip.scrollHeight - 1;
    }
    function by(dir) { strip.scrollBy({ top: dir * 190, behavior: 'smooth' }); }
    up.addEventListener('click', function () { by(-1); });
    down.addEventListener('click', function () { by(1); });
    strip.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    if (desktop.addEventListener) desktop.addEventListener('change', update);
    qsa('img', strip).forEach(function (img) { if (!img.complete) img.addEventListener('load', update); });

    /* mouse drag (touch and trackpad already scroll natively) */
    var startY = 0, startTop = 0, dragging = false, moved = false;
    strip.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !desktop.matches) return;
      dragging = true; moved = false; startY = e.clientY; startTop = strip.scrollTop;
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dy = e.clientY - startY;
      if (!moved && Math.abs(dy) > 5) { moved = true; strip.classList.add('is-dragging'); }
      if (moved) strip.scrollTop = startTop - dy;
    });
    function stop() { dragging = false; strip.classList.remove('is-dragging'); }
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);
    /* a drag must not select a thumbnail */
    strip.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    strip.addEventListener('dragstart', function (e) { e.preventDefault(); });

    update();
    window.setTimeout(update, 400);
  }

  /* ---------- main product ---------- */
    /* ---------- long option lists (e.g. 18 colors): wrap, convert unsupported swatch colors to text, collapse ---------- */
  function initOptionCollapse(root) {
    var limit = parseInt(root.getAttribute('data-option-limit'), 10) || 0;
    var moreTpl = root.getAttribute('data-text-options-more') || '+__COUNT__ more';
    var lessTxt = root.getAttribute('data-text-options-less') || 'Show less';

    qsa('.pdp-opt-swatch', root).forEach(function (btn) {
      var dot = qs('.pdp-dot', btn);
      if (dot && !dot.style.background && !dot.style.backgroundImage) {
        /* value is not a CSS color (e.g. "Blue 3pcs"): show it as a text chip instead of an empty circle */
        btn.classList.remove('pdp-opt-swatch');
        btn.classList.add('pdp-opt-chip');
        btn.textContent = btn.getAttribute('data-option-value');
      }
    });

    qsa('[data-option-group]', root).forEach(function (group) {
      var wrap = qs('.options__choices', group);
      var buttons = qsa('[data-option-value]', group);
      if (!wrap || !limit || buttons.length <= limit) return;
      var open = false;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'opt-more';
      wrap.appendChild(toggle);
      function paint() {
        var hiddenCount = 0;
        buttons.forEach(function (b, i) {
          var hide = !open && i >= limit && b.getAttribute('aria-pressed') !== 'true';
          b.hidden = hide;
          if (hide) hiddenCount += 1;
        });
        toggle.textContent = open ? lessTxt : moreTpl.replace('__COUNT__', hiddenCount);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      toggle.addEventListener('click', function () { open = !open; paint(); });
      document.addEventListener('product:variant:change', paint);
      paint();
    });
  }


  function initProduct(root) {
    if (!root || root.__pdp) return;
    var jsonNode = qs('[data-product-json]', root);
    if (!jsonNode) return;
    var data;
    try { data = JSON.parse(jsonNode.textContent); } catch (e) { return; }
    root.__pdp = true;

    var variants = data.variants || [];
    var form = qs('form.pdp-form', root);
    var idInput = qs('[data-variant-id]', root);
    var addBtn = qs('[data-add-to-cart]', root);
    var qtyWrap = qs('[data-quantity]', root);
    var qtyInput = qs('[data-qty-input]', root);
    var qtyDisplay = qs('[data-qty-display]', root);
    var qtyDown = qs('[data-qty-down]', root);
    var qtyUp = qs('[data-qty-up]', root);
    var slides = qsa('[data-slide]', root);
    var counter = qs('[data-gallery-counter]', root);
    var threshold = parseInt(root.getAttribute('data-low-stock'), 10) || 0;
    var T = function (name) { return root.getAttribute('data-text-' + name) || ''; };

    var current = null;
    variants.forEach(function (v) { if (v.id === data.currentVariantId) current = v; });
    if (!current) current = variants[0];
    if (!current) return;
    var options = current.options.slice();
    var qty = 1;
    var galleryIndex = 0;
    slides.forEach(function (s, i) { if (!s.hidden) galleryIndex = i; });

    /* gallery */
    function showSlide(i) {
      if (!slides.length) return;
      galleryIndex = (i + slides.length) % slides.length;
      var mediaId = slides[galleryIndex].getAttribute('data-media-id');
      slides.forEach(function (s, n) { s.hidden = n !== galleryIndex; });
      var thumbs = qsa('[data-thumb]', root);
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-media-id') === mediaId;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
        /* keep the active thumbnail visible inside the scrolling strip (desktop) without moving the page */
        var box = t.parentNode;
        if (on && box && box.scrollHeight > box.clientHeight + 1) {
          var top = t.offsetTop - box.offsetTop;
          if (top < box.scrollTop || top + t.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTop = Math.max(0, top - 8);
        }
      });
      if (counter) counter.textContent = T('counter').replace('__INDEX__', galleryIndex + 1).replace('__TOTAL__', slides.length);
      var strip = qs('[data-owl-mobile="thumbs"]', root);
      if (strip) owlGoTo(strip, galleryIndex);
    }
    function showMedia(mediaId) {
      if (mediaId == null) return;
      slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(mediaId)) showSlide(n); });
    }

    /* variants */
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    function closestVariant(index, value) {
      var best = null, bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[index] !== value) return;
        var score = 0;
        v.options.forEach(function (o, j) { if (j !== index && o === options[j]) score++; });
        if (v.available) score += 0.5;
        if (score > bestScore) { best = v; bestScore = score; }
      });
      return best;
    }
    function renderOptions() {
      qsa('[data-option-group]', root).forEach(function (group) {
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var label = qs('[data-option-selected]', group);
        if (label) label.textContent = options[index];
        qsa('[data-option-value]', group).forEach(function (btn) {
          var value = btn.getAttribute('data-option-value');
          var exists = false, available = false;
          variants.forEach(function (v) {
            if (v.options[index] !== value) return;
            for (var j = 0; j < options.length; j++) { if (j !== index && v.options[j] !== options[j]) return; }
            exists = true;
            if (v.available) available = true;
          });
          var on = options[index] === value;
          var suffix = !exists ? ', ' + T('unavailable-option') : (!available ? ', ' + T('sold-out-option') : '');
          btn.classList.toggle('is-on', on);
          btn.classList.toggle('is-out', !available);
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          btn.setAttribute('aria-label', btn.getAttribute('data-option-label') + suffix);
        });
      });
    }

    function setQty(n) {
      var rule = current.qty || {};
      var min = rule.min || 1, step = rule.step || 1, max = rule.max;
      if (n < min) n = min;
      if (max != null && n > max) n = max;
      qty = n;
      if (qtyInput) qtyInput.value = n;
      if (qtyDisplay) qtyDisplay.textContent = n;
      if (qtyDown) qtyDown.disabled = n - step < min;
      if (qtyUp) qtyUp.disabled = max != null && n + step > max;
    }

    function applyVariant(variant, fromUser) {
      current = variant;
      options = variant.options.slice();
      renderOptions();

      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var priceEl = qs('[data-price]', root);
      var compareEl = qs('[data-compare-price]', root);
      var saveEl = qs('[data-savings]', root);
      var badgeEl = qs('[data-discount-badge]', root);
      if (priceEl) priceEl.textContent = money(variant.price);
      var onSale = variant.compareAt > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? money(variant.compareAt) : ''; }
      if (saveEl) { saveEl.hidden = !onSale; saveEl.textContent = onSale ? T('save').replace('__AMOUNT__', money(variant.compareAt - variant.price)) : ''; }
      if (badgeEl) {
        badgeEl.hidden = !onSale;
        if (onSale) badgeEl.textContent = T('off').replace('__PERCENT__', Math.floor((variant.compareAt - variant.price) * 100 / variant.compareAt));
      }

      /* availability */
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? T('add') : T('sold-out');
      }
      qsa('[data-buy-now]', root).forEach(function (el) { el.hidden = !variant.available; });
      if (qtyWrap) qtyWrap.hidden = !variant.available;
      var stock = qs('[data-stock]', root);
      if (stock) {
        var low = false, text = T('in-stock');
        if (!variant.available) { low = true; text = T('out-of-stock'); }
        else if (threshold > 0 && variant.inventory != null && variant.inventory <= threshold) { low = true; text = T('low-stock').replace('__COUNT__', variant.inventory); }
        stock.textContent = text;
        stock.classList.toggle('is-low', low);
      }

      /* sku, pickup */
      var skuRow = qs('[data-sku-row]', root), skuVal = qs('[data-sku-value]', root);
      if (skuRow && skuVal) { skuRow.hidden = !variant.sku; skuVal.hidden = !variant.sku; skuVal.textContent = variant.sku || ''; }
      qsa('[data-pickup-for]', root).forEach(function (el) { el.hidden = el.getAttribute('data-pickup-for') !== String(variant.id); });

      setQty(qty);
      if (fromUser) {
        showMedia(variant.mediaId);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* history unavailable */ }
      }
      document.dispatchEvent(new CustomEvent('product:variant:change', { detail: { variant: variant, productId: data.id } }));
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      var thumb = t.closest('[data-thumb]');
      if (thumb) { showMedia(thumb.getAttribute('data-media-id')); return; }
      if (t.closest('[data-gallery-prev]')) { showSlide(galleryIndex - 1); return; }
      if (t.closest('[data-gallery-next]')) { showSlide(galleryIndex + 1); return; }
      var opt = t.closest('[data-option-value]');
      if (opt) {
        var group = opt.closest('[data-option-group]');
        var index = parseInt(group.getAttribute('data-option-index'), 10);
        var value = opt.getAttribute('data-option-value');
        var next = options.slice();
        next[index] = value;
        var variant = findVariant(next) || closestVariant(index, value);
        if (variant) applyVariant(variant, true);
        return;
      }
      if (t.closest('[data-qty-down]')) { setQty(qty - ((current.qty && current.qty.step) || 1)); return; }
      if (t.closest('[data-qty-up]')) { setQty(qty + ((current.qty && current.qty.step) || 1)); return; }
      if (t.closest('[data-buy-now-simple]') && form) {
        /* "Buy now" goes straight to checkout: bypass the AJAX add handler for this submit. */
        form.removeAttribute('data-ajax-add');
      }
    });

    /* after an AJAX add reset the quantity to the variant minimum */
    document.addEventListener('theme:cart:added', function (ev) {
      if (ev.detail && ev.detail.form === form) setQty((current.qty && current.qty.min) || 1);
    });

    /* Amazon-style hover zoom (desktop mouse only): lens on the image + magnified pane beside it */
        var galMain = qs('.gallery__main', root);
        var hoverZoom = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 992px)');
        if (galMain) {
          var ZOOM = 2.5;
          var lens = document.createElement('div');
          lens.className = 'zoom-lens';
          galMain.appendChild(lens);
          var pane = document.createElement('div');
          pane.className = 'zoom-pane';
          var paneImg = document.createElement('img');
          paneImg.alt = '';
          pane.appendChild(paneImg);
          document.body.appendChild(pane);

          var stopZoom = function () { lens.style.display = 'none'; pane.style.display = 'none'; };
          galMain.addEventListener('mousemove', function (e) {
            var img = qs('.pdp-slide:not([hidden]) img.main-img', galMain);
            if (!hoverZoom.matches || !img || e.target.closest('.gallery__controls')) { stopZoom(); return; }
            var r = galMain.getBoundingClientRect();
            var size = r.width / ZOOM;
            var left = Math.min(Math.max(e.clientX - r.left - size / 2, 0), r.width - size);
            var top = Math.min(Math.max(e.clientY - r.top - size / 2, 0), r.height - size);
            lens.style.cssText = 'display:block;width:' + size + 'px;height:' + size + 'px;left:' + left + 'px;top:' + top + 'px';
            var src = img.currentSrc || img.src;
            if (paneImg.getAttribute('src') !== src) paneImg.src = src;
            paneImg.style.cssText = 'position:absolute;max-width:none;object-fit:cover;width:' + (r.width * ZOOM) + 'px;height:' + (r.height * ZOOM) + 'px;left:' + (-left * ZOOM) + 'px;top:' + (-top * ZOOM) + 'px';
            pane.style.cssText = 'display:block;width:' + r.width + 'px;height:' + r.height + 'px;left:' + (r.right + window.pageXOffset + 16) + 'px;top:' + (r.top + window.pageYOffset) + 'px';
          });
          galMain.addEventListener('mouseleave', stopZoom);
          window.addEventListener('scroll', stopZoom, { passive: true });
        }


    initThumbScroller(root);
    initOptionCollapse(root);
    showSlide(galleryIndex);
    applyVariant(current, false);
    setQty((current.qty && current.qty.min) || 1);
  }

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('[data-faq-toggle]') : null;
    if (!btn) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    var panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
    var icon = qs('[data-faq-icon]', btn);
    if (icon) icon.setAttribute('d', open ? 'M12 5v14M5 12h14' : 'M5 12h14');
  });

  /* ---------- frequently bought together ---------- */
  function initBundle(sec) {
    if (!sec || sec.__fbt) return;
    sec.__fbt = true;
    var items = qsa('[data-fbt-item]', sec);
    var totalEl = qs('[data-fbt-total]', sec);
    var countEl = qs('[data-fbt-count-label]', sec);
    var addBtn = qs('[data-fbt-add]', sec);
    var busy = false;

    function selected() {
      return items.filter(function (it) { var c = qs('[data-fbt-check]', it); return c && c.checked && !c.disabled; });
    }
    function update() {
      var chosen = selected();
      var total = 0;
      items.forEach(function (it) {
        var c = qs('[data-fbt-check]', it);
        it.classList.toggle('is-on', !!(c && c.checked));
      });
      chosen.forEach(function (it) { total += parseInt(it.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = money(total);
      if (countEl) countEl.textContent = sec.getAttribute('data-text-total').replace('__COUNT__', chosen.length);
      if (addBtn) {
        addBtn.textContent = sec.getAttribute('data-text-add').replace('__COUNT__', chosen.length);
        addBtn.disabled = chosen.length === 0;
      }
    }
    sec.addEventListener('change', function (e) { if (e.target instanceof Element && e.target.matches('[data-fbt-check]')) update(); });
    document.addEventListener('product:variant:change', function (e) {
      var cur = qs('[data-fbt-current]', sec);
      if (!cur || !e.detail || !e.detail.variant) return;
      var v = e.detail.variant;
      cur.setAttribute('data-variant-id', v.id);
      cur.setAttribute('data-price', v.price);
      var priceEl = qs('[data-fbt-price]', cur);
      if (priceEl) priceEl.textContent = money(v.price);
      var c = qs('[data-fbt-check]', cur);
      if (c) { c.disabled = !v.available; if (!v.available) c.checked = false; }
      update();
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var chosen = selected();
        if (!chosen.length || busy) return;
        busy = true;
        addBtn.setAttribute('aria-busy', 'true');
        var payload = { items: chosen.map(function (it) { return { id: parseInt(it.getAttribute('data-variant-id'), 10), quantity: 1 }; }) };
        var url = ((Theme.routes && Theme.routes.cartAdd) || '/cart/add') + '.js';
        Theme.fetchJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
          .then(function () { return Theme.cart.refresh(); })
          .then(function () { if (Theme.toast) Theme.toast((Theme.strings && Theme.strings.addedToCart) || 'Added to cart'); })
          .catch(function (err) { if (Theme.toast) Theme.toast(err.message || '', { action: false }); })
          .then(function () { busy = false; addBtn.removeAttribute('aria-busy'); });
      });
    }
    update();
  }

  /* ---------- recommendations ---------- */
  function initRecommendations(box) {
    if (!box || box.__rec || !box.getAttribute('data-url')) return;
    box.__rec = true;
    if (box.children.length && box.querySelector('section')) return;
    fetch(box.getAttribute('data-url'))
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html || !html.trim()) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) box.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* recommendations are optional */ });
  }

  /* ---------- recently viewed ---------- */
  function initRecent(sec) {
    if (!sec || sec.__recent) return;
    sec.__recent = true;
    var handle = sec.getAttribute('data-current-handle');
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 5;
    var list = qs('[data-recent-list]', sec);
    var emptyMsg = qs('[data-recent-empty]', sec);
    var clearBtn = qs('[data-recent-clear]', sec);

    var stored = storageGet(RECENT_KEY).filter(function (h) { return h !== handle; });
    var others = stored.slice(0, limit);
    /* remember this product (most recent first) */
    storageSet(RECENT_KEY, [handle].concat(stored).slice(0, 20));
    if (!others.length) return;

    Promise.all(others.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      products.forEach(function (p) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=128' : '';
        html += '<li><a class="related-item" href="' + esc(p.url) + '">' +
          (img ? '<img class="related-item__image" src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '') +
          '<span class="related-item__text"><span class="related-item__name">' + esc(p.title) + '</span>' +
          '<span class="related-item__price">' + esc(money(p.price)) + '</span></span></a></li>';
      });
      if (!html) return;
      list.innerHTML = html;
      sec.hidden = false;
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        storageSet(RECENT_KEY, [handle]);
        list.innerHTML = '';
        list.hidden = true;
        clearBtn.hidden = true;
        if (emptyMsg) emptyMsg.hidden = false;
      });
    }
  }

  function initAll(scope) {
    scope = scope || document;
    qsa('[data-product-root]', scope).forEach(initProduct);
    qsa('[data-fbt]', scope).forEach(initBundle);
    qsa('[data-recommendations]', scope).forEach(initRecommendations);
    qsa('[data-recently-viewed]', scope).forEach(initRecent);
    syncOwl();
  }

  var resizeTimer;
  window.addEventListener('resize', function () { clearTimeout(resizeTimer); resizeTimer = setTimeout(syncOwl, 150); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
})();
